module.exports = __webpack_public_path__ + "img/dahlia.a508dc0e.png";